import { render } from "./form-type-common.vue?vue&type=template&id=da6d7e2e&ts=true"
import script from "./form-type-common.vue?vue&type=script&lang=ts"
export * from "./form-type-common.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__